module.exports = __webpack_public_path__ + "img/feefo_platinum_service_2023.2.8fe8c58.png";